import isFinite from 'lodash/isFinite';

const epc = (acceptedIncome, hosts) => {
	const res = acceptedIncome / hosts;
	return isFinite(res) && res.toFixed(2) || 0;
};

const crl = (totalConversions, hosts) => {
	const res = (totalConversions / hosts) * 100;
	return isFinite(res) && res.toFixed(2) || (0).toFixed(2);
};

const crs = (acceptedConversions, hosts) => {
	const res = (acceptedConversions / hosts) * 100;
	return isFinite(res) && res.toFixed(2) || (0).toFixed(2);
};

const approve = (acceptedConversions, totalConversions ) => {
	const res = (acceptedConversions / totalConversions) * 100;
	return isFinite(res) && res.toFixed(2) || 0;
};

const transitionPercent = (transitions, hits) => {
	const res = (transitions / hits) * 100;
	return isFinite(res) && res.toFixed(0) || 0;
};

const dow = dowIndex => {
	const newIndex = --dowIndex;
	return newIndex === -1 ? 6 : newIndex;
};

const redeemed = (redeemedConversions, acceptedConversions ) => {
	const res = (redeemedConversions / acceptedConversions) * 100;
	return isFinite(res) && res.toFixed(2) || (0).toFixed(2);
};

const reject = (rejectedConversions, totalConversions ) => {
	const res = (rejectedConversions / totalConversions) * 100;
	return isFinite(res) && res.toFixed(2) || 0;
};

export default {
	epc,
	crl,
	crs,
	approve,
	redeemed,
	transitionPercent,
	dow,
	reject
};


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/calculate-coefficients.js